import { matchPath, useLocation } from 'react-router-dom'

import {ROUTES} from "../config/constants";

export const useGetIdFromRoute = () => {
  const location = useLocation()

  const match = matchPath(`${ROUTES.RESET_PASSWORD}/:id`, location.pathname)

  return match?.params?.id ?? ''
}
